// Modules
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from 'ngx-bootstrap';
// Components
import { FormInputComponent } from '../internal/shared/form-input/form-input.component';
import { NoContent } from '../no-content/no-content';

@NgModule({
  imports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    TranslateModule,
    ButtonsModule
  ],
  declarations: [
    // Components
    FormInputComponent,
    NoContent
  ],
  exports: [
    // Modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    TranslateModule,
    ButtonsModule,

    // Components
    FormInputComponent,
    NoContent
  ]
})
export class SharedModule {}
